import makeStyles from "@mui/styles/makeStyles";

import { relativeBackgrounds } from "utils/relativeUtils";

export default makeStyles(
  (theme) => ({
    root: {
      minHeight: 22,
      maxWidth: 56,
      minWidth: 46,
      padding: [6, 10],
      fontSize: theme.typography.pxToRem(10),
      whiteSpace: "no-wrap",
      textAlign: "center",
      borderRadius: 86,
      border: "none",
      "& > span": {
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      [theme.breakpoints.up("mobile")]: {
        minHeight: 25,
        minWidth: 59,
        maxWidth: 86,
        padding: [7, 12],
        fontSize: theme.typography.pxToRem(12),
      },
    },
    clickable: {
      cursor: "pointer",
    },
    ...relativeBackgrounds(theme),
  }),
  { name: "PersonLabel" },
);
